import React from 'react';
import styles from './PageLayoutAuth.module.scss';
import cx from 'classnames';
import { Button } from '../../Button/Button';
import { ReactComponent as LogoSVG } from '../../../../assets/auth/auth-logo.svg';
import { IconFont } from '../../Icons/IconFont/IconFont';
import { PageLayoutAuthBg } from './PageLayoutAuthBg/PageLayoutAuthBg';
import { TranslateMessage } from '../../Translations/TranslateMessage/TranslateMessage';

export interface Props {
  title?: string | React.ReactNode;
  onClickClose?: () => void;
  onClickBack?: () => void;
  hasLogo?: boolean;
  noPinBottom?: boolean;
  className?: string;
  country?: string;
  bgSrc?: string;
}

const PageLayoutAuth: React.FC<Props> = ({
  title,
  onClickClose,
  onClickBack,
  hasLogo,
  className,
  noPinBottom,
  country,
  bgSrc,
  children,
}) => {
  const classNames = cx(styles.layout, className, {
    [styles.layout_canPinBottom]: !noPinBottom,
    [styles[`layout_country-${country}`]]: country,
  });

  return (
    <div className={classNames}>
      {bgSrc ? (
        <div className={styles.layoutBg}>
          <picture>
            <img src={bgSrc} alt="" />
          </picture>
        </div>
      ) : (
        <PageLayoutAuthBg country={country} />
      )}
      <div className={styles.panelWrapper}>
        <div className={styles.panel}>
          {hasLogo && (
            <div className={styles.panelLogo}>
              <div className={styles.logo}>
                <LogoSVG />
              </div>
              <div className={styles.tagline}>
                <TranslateMessage id={'general.planSmarterGrowBetter'} />
              </div>
            </div>
          )}
          {(title || onClickBack || onClickClose) && (
            <div className={styles.panelHeader}>
              {onClickBack && (
                <div className={styles.back}>
                  <Button
                    type={'secondary'}
                    iconEl={
                      <IconFont name={'arrow-left'} color={'black'} size={24} />
                    }
                    onClick={onClickBack}
                  />
                </div>
              )}
              <div className={styles.title}>{title}</div>
              {onClickClose && (
                <div className={styles.close}>
                  <Button
                    type={'secondary'}
                    iconEl={
                      <IconFont name={'exit'} color={'black'} size={16} />
                    }
                    onClick={onClickClose}
                  />
                </div>
              )}
            </div>
          )}
          <div className={styles.panelBody}>{children}</div>
        </div>
      </div>
    </div>
  );
};

export { PageLayoutAuth };
